import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

interface CachedResponse {
  body: unknown;
  status: number;
  timestamp: number;
}

const STORAGE_PREFIX = 'mock_cache::';
const ENABLED_KEY = 'mock_cache_enabled';

@Injectable({ providedIn: 'root' })
export class MockBackendService {
  private excludePatterns: RegExp[] = [/\/auth\//, /\/login/];

  constructor() {
    this.initializeEnabled();
    this.exposeConsoleControls();
  }

  get enabled(): boolean {
    return false;
    // return localStorage.getItem(ENABLED_KEY) === 'true';
  }

  private initializeEnabled(): void {
    const currentValue = localStorage.getItem(ENABLED_KEY);
    if (currentValue === null) {
      localStorage.setItem(ENABLED_KEY, 'true');
      console.log('[MockCache] 🚀 Auto-enabled on first load');
    }
  }

  enable(): void {
    localStorage.setItem(ENABLED_KEY, 'true');
    console.log('[MockCache] ✅ Enabled - refresh to apply');
  }

  disable(): void {
    localStorage.setItem(ENABLED_KEY, 'false');
    console.log('[MockCache] ❌ Disabled - refresh to apply');
  }

  clear(): void {
    Object.keys(localStorage)
      .filter(k => k.startsWith(STORAGE_PREFIX))
      .forEach(k => localStorage.removeItem(k));
    console.log('[MockCache] 🗑️ Cleared');
  }

  shouldCache(url: string): boolean {
    if (!this.enabled) {
      return false;
    }
    return !this.excludePatterns.some(p => p.test(url));
  }

  createKey(method: string, url: string, body?: unknown): string {
    const bodyStr = body ? JSON.stringify(body) : '';
    return `${method}::${url}::${bodyStr}`;
  }

  getFromStorage(key: string): CachedResponse | null {
    try {
      const data = localStorage.getItem(STORAGE_PREFIX + key);
      return data ? JSON.parse(data) : null;
    } catch {
      return null;
    }
  }

  saveToStorage(key: string, res: HttpResponse<unknown>): void {
    const cached: CachedResponse = {
      body: res.body,
      status: res.status,
      timestamp: Date.now(),
    };
    try {
      localStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(cached));
    } catch {
      console.warn('[MockCache] Storage full');
    }
  }

  private exposeConsoleControls(): void {
    (window as any).mockCache = {
      enable: () => this.enable(),
      disable: () => this.disable(),
      clear: () => this.clear(),
      status: () => console.log(this.enabled ? '✅ Enabled' : '❌ Disabled'),
    };
  }
}
